
import AnimatedText from '../../../components/base/AnimatedText';

export default function ContactSection() {
  return (
    <section id="contact" className="py-20 bg-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://public.readdy.ai/ai/img_res/06fb2afb33fa12c770e4cf44baa4d5e8.jpg"
          alt="Background"
          className="w-full h-full object-cover object-top"
        />
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <AnimatedText
            text="ご予約・お問い合わせ"
            className="text-4xl font-bold text-white mb-4"
          />
          <div className="w-24 h-1 bg-blue-500 mx-auto mb-6"></div>
          <AnimatedText
            text="特別な夜のご予約をお待ちしております"
            className="text-xl text-gray-300"
            delay={300}
          />
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-black/70 backdrop-blur-sm rounded-lg p-12 border border-blue-500/20 text-center">
            <h3 className="text-3xl font-bold text-white mb-8 flex items-center justify-center">
              <i className="ri-phone-line text-blue-500 text-3xl mr-4"></i>
              お電話でのご予約
            </h3>
            
            <div className="mb-8">
              <p className="text-5xl font-bold text-blue-400 mb-4">078-954-6898</p>
              <p className="text-xl text-gray-300">営業時間内にお電話ください</p>
            </div>
            
            <div className="border-t border-gray-700 pt-8">
              <h4 className="text-white font-semibold mb-4 text-xl">営業時間</h4>
              <div className="text-lg text-gray-300 space-y-2">
                <p>営業時間: 20:00 - 01:00</p>
                <p>定休日: 毎月1日、水曜、土曜</p>
              </div>
            </div>
            
            <div className="mt-8 pt-8 border-t border-gray-700">
              <p className="text-gray-300 leading-relaxed text-lg">
                神戸三宮の夜を彩る特別な空間で、皆様をお迎えいたします。<br />
                洗練されたキャストと上質なサービスで、忘れられない時間をお約束いたします。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
